const Accordion = () => {
  const thumbnails = document.querySelectorAll('.thumbnails')

  thumbnails &&
    Array.prototype.forEach.call(thumbnails, function (elm) {
      Array.prototype.forEach.call(
        elm.querySelectorAll('article'),
        function (article) {
          const btn = article.querySelector('.expand')
          if (!btn) return

          const contentTag = btn.closest('div')
          const content =
            contentTag.querySelector('.expand-adv') ||
            contentTag.querySelector('p:last-of-type')
          const controls = btn.getAttribute('aria-controls') || content?.id
          if (content && controls) {
            content.id = controls
          }
          if (content && !btn.getAttribute('aria-controls')) {
            btn.setAttribute('aria-controls', content.id)
          }

          btn.addEventListener('click', () => {
            const isExpanded = btn.getAttribute('aria-expanded') === 'true'
            if (isExpanded) {
              btn.classList.add('expand')
              btn.setAttribute('aria-expanded', 'false')
              btn.textContent = 'Read More'
            } else {
              btn.classList.remove('expand')
              btn.setAttribute('aria-expanded', 'true')
              btn.textContent = 'Read Less'
            }
          })
        },
      )
    })
}

export default Accordion
